import ProgressBarWidget from 'components/Widgets/ProgressBar';

const ProgressTypeFields = ({ selectItem, setNewSelectItem, item, disabled }) => {
  return (
    <ProgressBarWidget
      selected={selectItem}
      onChange={setNewSelectItem}
      item={item}
      disabled={disabled}
    />
  );
};

export default ProgressTypeFields;
